import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import TermsContent from '../components/TermsContent';

const TermsPage = () => {
  const navigate = useNavigate();

  /**
   * Safe back behavior. `navigate(-1)` is a dead-end for direct visits
   * (shared link, new tab opened with target="_blank", PWA cold-start, etc.)
   * because the router history stack is empty. Fall back to the home route
   * in those cases so the user is never stranded.
   */
  const handleBack = () => {
    const hasHistory =
      typeof window !== 'undefined' && window.history && window.history.length > 1;
    if (hasHistory) {
      navigate(-1);
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <div className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
        <button
          onClick={handleBack}
          className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-700 mb-6"
          data-testid="terms-back-button"
        >
          <ArrowLeft className="h-4 w-4" /> Back
        </button>

        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
        <p className="text-sm text-gray-400 mb-8">Last updated: April 2026</p>

        <TermsContent />
      </div>
      <Footer />
    </div>
  );
};

export default TermsPage;
